module.exports = __webpack_public_path__ + "static/eco_03-54ce2f563fe1472da178b2552381c647.jpg";